import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss']
})
export class CustomSelectComponent implements OnInit {
  isOpen = false;
  options;
  dropdownHeight = 'initial';
  selectedOption;
  openOption;
  showAmount = false;
  selectedAmount;
  amounts;
  @Input()
  set SelectOptions(options) {
    this.options = options || [];
    this.dropdownHeight = `${this.options.length * 34 + 10}px`;
  }

  @Input()
  set DefaultOption(option) {
    this.selectedOption = option;
  }

  @Input()
  set IsSelectOpen(status) {
    this.isOpen = status;
  }

  @Input()
  set ShowAmount(price) {
    this.showAmount = price;
    this.amounts = this.options.map(parts => {
      const commitmentAmount = parts * price;
      return parseFloat(commitmentAmount.toFixed(2));
    });
  }

  @Output() selectChanged = new EventEmitter<any>();
  @Output() isSelectButtonOpen = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  selected(option) {
    this.selectedOption = option;
    if (this.showAmount) {
      this.selectedAmount = this.amounts[this.options.indexOf(option)];
    }
    this.isOpen = !this.isOpen;
    this.selectChanged.emit(this.selectedOption);
  }

  selectButtonClicked() {
    this.isOpen = !this.isOpen;
    this.isSelectButtonOpen.emit(this.isOpen);
  }
}
